import React from 'react';

interface Props {
  id: string;
  label: string;
  checked?: boolean;
  onClick: (e) => void;
}

const AccountCheckbox: React.FC<Props> = ({
  id,
  label,
  checked = false,
  onClick,
}) => (
  <React.Fragment>
    <div className="checkbox-group">
      <input
        type="checkbox"
        name={id}
        id={id}
        onClick={onClick}
        defaultChecked={checked}
      />
      <label htmlFor={id}>{label}</label>
    </div>
    {/* language=CSS */}
    <style jsx>{`
      .checkbox-group label {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
      }
    `}</style>
  </React.Fragment>
);

export default AccountCheckbox;
